import FaxIcon from "@mui/icons-material/Fax";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Banner from "../../assets/images/home-page/home_banner_2.jpg";
import PlaceIcon from "@mui/icons-material/Place";
import PaymentIcon from "@mui/icons-material/Payment";
import { Link } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language";
const HomePageBanner = () => {
  return (
    <div
      className="w-full z-20 h-[800px] lg:h-[850px] xl:h-[900px] 2xl:h-screen relative "
      style={{
        backgroundImage: `url(${Banner})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="w-full flex xl:hidden absolute top-14 justify-center font-roboto">
        <ul className="w-11/12 md:w-4/5 py-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
          {/* Phone */}
          <li className="bg-[#bf9c5e] font-semibold text-white text-center rounded-lg shadow-md hover:shadow-lg transition">
            <a
              href="tel:3524508062"
              className="text-lg py-3 flex gap-2 items-center justify-center flex-wrap"
            >
              <LocalPhoneIcon className="text-[#fff] font-bold homebannerIcon" />
              (352) 450-8062
            </a>
          </li>

          {/* Fax */}
          <li className="bg-[#bf9c5e] font-semibold text-white text-center rounded-lg shadow-md hover:shadow-lg transition">
            <a
              href="/"
              className="text-lg py-3 flex gap-2 items-center justify-center flex-wrap"
            >
              <FaxIcon className="text-[#fff] font-bold homebannerIcon" />
              352-795-6460
            </a>
          </li>

          {/* Abbadox Portal */}
          <li className="bg-[#bf9c5e] font-semibold text-white text-center rounded-lg shadow-md hover:shadow-lg transition">
            <Link
              to="/for-patient#abbadox-portal"
              className="text-lg py-3 flex gap-2 items-center justify-center flex-wrap"
            >
              <LanguageIcon className="text-[#fff] font-bold homebannerIcon" />
              Portal Login 
            </Link>
          </li>
           <li className="bg-[#bf9c5e] font-semibold text-white text-center rounded-lg shadow-md hover:shadow-lg transition">
            <Link
              to="/for-patient#abbadox-portal"
              className="text-lg py-3 flex gap-2 items-center justify-center flex-wrap"
            >
              <LanguageIcon className="text-[#fff] font-bold homebannerIcon" />
              PACS
            </Link>
          </li>

          {/* Payment */}
          <li className="bg-[#bf9c5e] font-semibold text-white text-center rounded-lg shadow-md hover:shadow-lg transition">
            <Link
              to="/make-a-payment"
              className="text-lg  py-3 flex gap-2 items-center justify-center flex-wrap"
            >
              <PaymentIcon className="text-[#fff] font-bold homebannerIcon" />
              Bill Pay
            </Link>
          </li>

          {/* PACS Portal */}
         
          {/* Find Us */}
          <li className="bg-[#bf9c5e] font-semibold text-white text-center rounded-lg shadow-md hover:shadow-lg transition">
            <a
              href="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
              target="_blank"
              rel="noreferrer noopener"
              className="text-lg py-3 flex gap-2 items-center justify-center flex-wrap"
            >
              <PlaceIcon className="text-[#fff] font-bold homebannerIcon" />
              Find Us
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HomePageBanner;
